import { Button, Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { Link, BaseButton, Gutter } from '@common/components';

import { buildDialogUrl } from '@common/services';
import { MakeOfferDrawerWithButton } from './make-offer-drawer-with-button';
import PerformApplicationActionButton from './perform-application-action-button';
import PerformOfferActionButton from './perform-offer-action-button';

function renderButtons({ application, offer, staffingRequest }) {
  const submittedStates = ['submitted', 'submittal_packet_change_requested'];

  const offerPreviewDrawerUrl = buildDialogUrl('offer-preview-drawer', {
    props: { offerId: offer?.id || '' },
  });

  const rejectApplicationDrawerUrl = buildDialogUrl(
    'application-rejection-drawer',
    {
      props: { applicationId: application.id },
    }
  );

  if (
    submittedStates.includes(application.state) &&
    staffingRequest.state === 'OPEN'
  ) {
    return (
      <Row gutter={[8, 8]}>
        <Col>
          <PerformApplicationActionButton
            state="review"
            application={application}
          >
            Shortlist for Review
          </PerformApplicationActionButton>
        </Col>
        <Col>
          <Link to={rejectApplicationDrawerUrl}>
            <Button type="secondary" danger>
              Reject
            </Button>
          </Link>
        </Col>
      </Row>
    );
  }

  if (application.state === 'in_review' && staffingRequest.state === 'OPEN') {
    return (
      <Row gutter={[8, 8]}>
        <Col>
          <MakeOfferDrawerWithButton application={application}>
            Send Offer
          </MakeOfferDrawerWithButton>
        </Col>
        <Col>
          <Link to={rejectApplicationDrawerUrl}>
            <Button type="secondary" danger>
              Reject
            </Button>
          </Link>
        </Col>
      </Row>
    );
  }

  if (
    application.state === 'offer' &&
    ['offered', 'change_requested'].includes(offer?.state)
  ) {
    if (staffingRequest.state === 'OPEN') {
      return (
        <Row gutter={[8, 8]}>
          <Col>
            <Link to={offerPreviewDrawerUrl}>
              <Button>View Offer</Button>
            </Link>
          </Col>
          <Col>
            <PerformOfferActionButton
              state="retract"
              offer={offer}
              type="secondary"
              danger
            >
              Retract
            </PerformOfferActionButton>
          </Col>
        </Row>
      );
    }

    if (staffingRequest.state === 'ON_HOLD') {
      return (
        <Link to={offerPreviewDrawerUrl}>
          <Button type="secondary">View Offer</Button>
        </Link>
      );
    }
  }

  if (application.state === 'offer' && (!offer || offer.state === 'rejected')) {
    if (staffingRequest.state === 'OPEN') {
      return (
        <Row gutter={[8, 8]}>
          <Col>
            <Link to={offerPreviewDrawerUrl}>
              <Button>View Offer</Button>
            </Link>
          </Col>
          <Col>
            <MakeOfferDrawerWithButton
              application={application}
              type="secondary"
            >
              New Offer
            </MakeOfferDrawerWithButton>
          </Col>
        </Row>
      );
    }

    if (staffingRequest.state === 'ON_HOLD') {
      return (
        <Link to={offerPreviewDrawerUrl}>
          <Button type="secondary">View Offer</Button>
        </Link>
      );
    }
  }

  if (application.state === 'accepted' && offer) {
    return (
      <Row gutter={[8, 8]}>
        <Col>
          <Link
            to={`/works/team/long_term/${offer.staffingRequestAssignment.id}/compliance`}
          >
            <BaseButton type="primary">Assignment</BaseButton>
          </Link>
        </Col>
        <Col>
          <Link to={offerPreviewDrawerUrl}>
            <Button type="secondary">View Offer</Button>
          </Link>
        </Col>
      </Row>
    );
  }

  if (application.state === 'rejected' && staffingRequest.state === 'OPEN') {
    const state = application.canSubmit.value ? 'submit' : 'review';
    return (
      <PerformApplicationActionButton state={state} application={application}>
        Unreject
      </PerformApplicationActionButton>
    );
  }
}

export default function StateAreaButtons(props) {
  return (
    <Gutter size="xs" direction="top">
      {renderButtons({ ...props })}
    </Gutter>
  );
}

StateAreaButtons.propTypes = {
  application: PropTypes.shape({
    id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    stateChangedAt: PropTypes.string.isRequired,
  }),

  offer: PropTypes.shape({
    id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
  }),

  staffingRequest: PropTypes.shape({
    state: PropTypes.string.isRequired,
  }),
};
